import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function MoreTestimonials() {
  const testimonials = [{
    initials: 'CR',
    quote: 'Sentía miedo constantemente y este ebook me ayudó muchísimo a entender qué era normal y qué no.',
    author: 'Camila R.',
    location: 'Mendoza',
    color: 'bg-peach-bg text-peach-dark'
  }, {
    initials: 'SC',
    quote: 'Lo mejor fue el tono. No te hace sentir culpable ni tonta. Sentís que alguien realmente te acompaña.',
    author: 'Sofía C.',
    location: 'La Plata',
    color: 'bg-sage-light text-sage'
  }, {
    initials: 'PA',
    quote: 'El capítulo del recién nacido me salvó las primeras semanas. Lo tenía abierto todo el tiempo.',
    author: 'Paula A.',
    location: 'Neuquén',
    color: 'bg-peach-bg text-peach-dark'
  }, {
    initials: 'JM',
    quote: 'El bonus de recuperación postparto me emocionó muchísimo. Necesitaba leer algo así.',
    author: 'Julia M.',
    location: 'Rosario',
    color: 'bg-sage-light text-sage'
  }, {
    initials: 'MV',
    quote: 'La información es clara, simple y transmite muchísima tranquilidad.',
    author: 'María V.',
    location: 'Tucumán',
    color: 'bg-peach-bg text-peach-dark'
  }, {
    initials: 'GR',
    quote: 'Por primera vez sentí que alguien me explicaba maternidad sin hacerme sentir peor.',
    author: 'Gabriela R.',
    location: 'Santa Fe',
    color: 'bg-sage-light text-sage'
  }];
  return <section className="py-20 md:py-28 bg-cream" data-id="element-215">
      <div className="max-w-6xl mx-auto px-6" data-id="element-216">
        <div className="text-center mb-16" data-id="element-217">
          <span className="inline-block text-xs md:text-sm font-bold tracking-[0.3em] text-peach-dark uppercase mb-4" data-id="element-218">
            ❤️ MÁS MAMÁS QUE YA LO TIENEN
          </span>
          <h2 className="font-serif text-text-dark leading-[1.05] tracking-tight mb-4" style={{
          fontSize: 'clamp(2rem, 5vw, 4rem)'
        }} data-id="element-219">
            +2.000 mamás transformaron su maternidad
          </h2>
          <div className="flex items-center justify-center gap-2 text-lg text-text-muted" data-id="element-220">
            <div className="flex text-yellow-500" data-id="element-221">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-222" />)}
            </div>
            <span data-id="element-223">4.9/5 · basado en +2.000 opiniones</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-224">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-white p-8 rounded-3xl shadow-sm border border-peach-light/50 relative" data-id="element-225">
              <div className="absolute -top-6 left-8" data-id="element-226">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center font-serif font-bold text-lg ${t.color}`} data-id="element-227">
                  {t.initials}
                </div>
              </div>
              <div className="flex text-yellow-500 mb-4 mt-2" data-id="element-228">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-229" />)}
              </div>
              <p className="text-text-dark italic mb-6 leading-relaxed" data-id="element-230">
                "{t.quote}"
              </p>
              <div className="flex flex-col" data-id="element-231">
                <span className="font-medium text-text-dark" data-id="element-232">{t.author}</span>
                <span className="text-sm text-text-muted" data-id="element-233">— {t.location}</span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}